export const en = {
	Язык: 'Language',
};
